const Kategoriya2211 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 2-chorak<br />
                Mavzu: Tutuq belgisi haqida bilib olamiz <br />
“Eng oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Tutuq belgisi to‘g‘ri qo‘yilgan so‘zlarning tagiga chizing.</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning so‘zlar imlosi ustida ishlash ko‘nikmalarini rivojlantirish. <br />
            <i>Mashg‘ulot davomiyligi:</i> 3 daqiqa.<br />
            <p>Ma’no, isted’od, mas’ul, dav’o, ma’lum, ma’lumot.</p>
            <p><b>2-mashq. Juftlikda ishlang. Kerakli o‘rinlarga tutuq belgisi qo‘ying va yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i> O‘quvchilarning so‘zlar imlosi ustida ishlash ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-break">Malumot - ____________________________________</p>
            <p className="text-break">Talim - _______________________________________</p>
            <p className="text-break">Manaviyat - ____________________________________</p>
            <p>Taziya - _________________________________________</p>
            <p><b>3-mashq. Tez aytishni davom ettiring, nuqtalar o‘rniga mos so‘zni qo‘ying.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning bog‘lanishli nutqini rivojlantirish ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p>Moshdan tosh, toshdan …. bo‘lmas.</p>
            <p>Qurbaqa qurillaydi, …. chirillaydi.</p>
        </div>
    )
}
export default Kategoriya2211;